module.exports = __webpack_public_path__ + "static/img/invited-five.2022e15f.png";